import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ContactsOutlinedSvg from "@ant-design/icons-svg/es/asn/ContactsOutlined";
import AntdIcon from "../components/AntdIcon";
var ContactsOutlined = function ContactsOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ContactsOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  ContactsOutlined.displayName = 'ContactsOutlined';
}
export default /*#__PURE__*/React.forwardRef(ContactsOutlined);